import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=64389794&scoped=true&"
import script from "./userMenu.vue?vue&type=script&lang=js&"
export * from "./userMenu.vue?vue&type=script&lang=js&"
import style0 from "./userMenu.vue?vue&type=style&index=0&id=64389794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64389794",
  null
  
)

export default component.exports